<form [formGroup]="marketingBannerForm">
  @if (loading) {
    <div class="loading-indicator">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <div class="pagehd section">Marketing Message</div>

  <div class="section">
    <div class="section-head">Program Type</div>
    <div class="programTypeDropDown">
      <p-select
        [options]="programTypes"
        formControlName="programType"
        placeholder="Program Type"
        optionLabel="programTypeName"
        optionValue="programTypeId"
        (onChange)="onProgramTypeChange($event)"></p-select>
    </div>
    <div class="banner-message-header">
      <div class="section-head">Banner message</div>
      <div class="section-head-sub-text">
        ({{ getLimit }} characters remaining)
      </div>
    </div>
    <textarea
      pTextarea
      class="banner-message-text"
      formControlName="bannerMessage"
      maxlength="32"></textarea>

    <div class="linkToLearnMore-message-header">
      <div class="section-head">Link to learn more</div>
    </div>
    <input
      class="linkToLearnMore-message"
      text="text"
      formControlName="linkToLearnMore" />

    @if (isActive) {
      <div class="banner-status-message">
        <div class="ui-icon-warning"></div>
        <div>
          This banner is currently running, press Stop Banner to end or edit
          Banner message
        </div>
      </div>
    }

    <div class="banner-button-container">
      <button
        type="button"
        pButton
        class="banner-button-container ui-button-info"
        (click)="startStopBanner()"
        [disabled]="!isStartButton">
        {{ startStopText }}
      </button>
      <button
        type="button"
        pButton
        class="banner-button-container ui-button-info"
        (click)="updateBanner()"
        [disabled]="isUpdateButton">
        Update Banner
      </button>
    </div>
  </div>

  <div class="section">
    <app-marketing-banner-history
      #marketingBannerHistory></app-marketing-banner-history>
  </div>
</form>
